import { Fragment } from 'react';
import { IconButton, useEventCallback } from '@mui/material';
import { createSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ActionProps } from 'shell/view-models/actions-props';
import { Edit } from '@mui/icons-material';
import { FiltersFormPerson } from 'shell/view-models/search-anpr';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { DefaultFilterTable } from 'shell/constants/person-search';

const ActionsListPresumedUnavailability = ({
  cell,
  filterPersonForm,
}: ActionProps): React.ReactElement => {
  const navigate = useNavigate();
  const personFilterTable = useFilterTable<FiltersFormPerson>();

  const onEditPress = useEventCallback(() => {
    return new Promise((resolve) => {
      personFilterTable.setValues(DefaultFilterTable);

      navigate({
        pathname: '/cancellazioni/cancellazione-aire/irreperibilita-presunta/cancellazione',
        search: `?${createSearchParams({
          ricercaNazionale:
            filterPersonForm?.subjectData?.isNationalResearch?.toString() ||
            filterPersonForm?.commonSearch?.isNationalResearch?.toString() ||
            'false',
          codiceFiscale: cell?.fiscalCode || '',
          idSchedaSoggettoANPR: cell?.anpr || '',
        })}`,
      });
      resolve(cell);
    });
  });

  return (
    <Fragment>
      <IconButton
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onEditPress();
        }}
        aria-label="Modifica elemento"
        aria-haspopup="true"
        style={{
          padding: '4px',
        }}
      >
        <Edit />
      </IconButton>
    </Fragment>
  );
};

ActionsListPresumedUnavailability.displayName =
  'Action list presumed unavailability Persons page component';

export default ActionsListPresumedUnavailability;
